import { Controller } from 'stimulus'
import template from 'lodash.template'

export default class extends Controller {
  connect() {
    console.log('Styleguide Stimulus connected.')
  }

  triggerToastSamples() {
    const tmpl = document.querySelector('#toast_notification_samples')
    const compiledTmpl = template(tmpl.innerHTML)

    $('body').append(compiledTmpl())
  }

  logSerializedForm(event) {
    const form = event.currentTarget.closest('form')

    alert('Underlying form params:\n\n ' + JSON.stringify($.deparam($(form).serialize())))
  }
}
